export default "__VITE_ASSET__BdJlFZa4__"